export default {
      id: "partner2-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svgsprite.svg#partner2",
      toString: function () {
        return this.url;
      }
    }